import declare from "dojo/_base/declare";
import StoreNodesConstructor from "./Nodes";
import DataStoreValues from "./DataStoreValues";
import DataStoreValuePairs from "./DataStoreValuePairs";

// TODO: figure out what to do about sorting
// TODO: add support for charting and count

const DataStoreNodes = declare(StoreNodesConstructor, {
	chartClass: null,
	requestModule: "DataStore",
	requestOperation: "GetNodes",
	requestOperationCount: null,
	valuesClass: DataStoreValues,
	valuePairsClass: DataStoreValuePairs,

});

export = DataStoreNodes;